export default __webpack_public_path__ + "static/media/person2.b2548cf8.png";